export default "__VITE_PUBLIC_ASSET__2375b3db__"